<div
  class="py-12 text-center max-w-6xl mx-auto px-4 flex flex-col min-h-[75vh]"
  [class.justify-center]="!loading() && draftProperties().length === 0"
>
  <!-- Greeting Header -->
  <header class="mb-12">
    <h1 class="text-4xl font-extrabold tracking-tight text-gray-12 sm:text-6xl mb-6">
      Nous sommes ravis de vous revoir,
      <span class="text-primary font-black">{{ user()?.identity?.firstName }}</span>
    </h1>
    <p class="text-xl text-gray-11 max-w-2xl mx-auto leading-relaxed">
      Prêt à concrétiser une nouvelle vente ?<br />
      Commencez dès maintenant
      @if (loading() || draftProperties().length > 0) {
        ou reprenez vos annonces en cours.
      }
    </p>
  </header>

  <!-- Main CTA -->
  <div class="mb-20 flex flex-col items-center">
    <button
      mat-flat-button
      class="primary px-12 py-9 text-2xl shadow-xl hover:shadow-2xl hover:scale-105 transition-all duration-300"
      (click)="newClicked.emit()"
    >
      <mat-icon class="mr-3 scale-150">add_circle</mat-icon>
      Créer une nouvelle annonce
    </button>
  </div>

  <!-- Drafts Section -->
  <etxe-property-draft-list
    [drafts]="draftProperties()"
    [loading]="loading()"
    (draftSelected)="selectDraft($event)"
    (draftDeleted)="deleteDraft($event)"
  />
</div>
